import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Policy from './Policy'

import {
  acceptPolicies,
  showAcceptPoliciesModal,
  userIsConsideringDecliningPolicies
} from '../../actions/policies'
import { decline } from '../../utils/messages'

export default class Policies extends Component {
  constructor(props) {
    super(props)
    this.onAgreeClickBound = this.onAgreeClick.bind(this)
    this.onDeclineClickBound = this.onDeclineClick.bind(this)
  }

  render() {
    var policies = this.props.policies.map(function (policy, index) {
      return <Policy key={policy.id} policy={policy} show={index === 0} />
    })

    var policyTabHeaders = this.props.policies.map(function (policy, index) {
      return (
        <li
          key={index}
          data-slug={policy.slug}
          onClick={this.onTabHeaderClick}
          className={index === 0 ? 'active' : ''}
        >
          {policy.name}
        </li>
      )
    }, this)

    return (
      <div id="viewOurPoliciesWrapper">
        <h2>
          <FormattedMessage
            id="Policies.OurPolicies"
            defaultMessage="Our Policies"
          />
        </h2>
        {!this.props.displayActions && <div>&nbsp;</div>}
        {this.props.displayActions && (
          <p>
            <FormattedMessage
              id="Policies.ThankYouForYourInterest"
              defaultMessage='Thank you for your interest in our products and services. To use
              our apps, you must agree to the terms below. Please read them
              carefully and click "Agree to OE Policies" to confirm your
              agreement to these terms.'
            />
          </p>
        )}
        <ul id="policyTabsHeader">{policyTabHeaders}</ul>
        <ul id="policyTabs">{policies}</ul>
        {this.props.displayActions && (
          <div>
            <div id="ourPoliciesFooter"></div>
            <div className="actions">
              <div
                className="agree button active"
                onClick={this.onAgreeClickBound}
              >
                <FormattedMessage
                  id="Policies.Agree"
                  defaultMessage="AGREE TO OE POLICIES"
                />
              </div>
              <div className="decline" onClick={this.onDeclineClickBound}>
                {decline}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  onAgreeClick() {
    this.props.dispatch(acceptPolicies())
  }

  onDeclineClick() {
    this.props.dispatch(userIsConsideringDecliningPolicies())
    this.props.dispatch(showAcceptPoliciesModal())
  }

  onTabHeaderClick(e) {
    const clickedEl = e.currentTarget
    const slug = clickedEl.getAttribute('data-slug')
    const headerTabEls = document.querySelectorAll('#policyTabsHeader li')
    const tabEls = document.querySelectorAll('#policyTabs li')
    const el = document.querySelector('#policyTabs li#' + slug)

    // remove all active items from tab headers
    for (var i = 0; i < headerTabEls.length; i++) {
      headerTabEls[i].classList.remove('active')
    }
    // remove all active items from tabs
    for (var x = 0; x < tabEls.length; x++) {
      tabEls[x].classList.remove('active')
    }

    el.className += ' active'
    clickedEl.className += 'active'
  }
}

Policies.propTypes = {
  dispatch: PropTypes.func,
  policies: PropTypes.array.isRequired,
  displayActions: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/policies/Policies.js